// src/components/TipoEnvase/TipoEnvase.styles.ts

import styled from 'styled-components';
const colors = {
  primary: '#0052CC',
  background: '#f8f9fa',
  cardBackground: '#FFFFFF',
  textPrimary: '#172B4D',
  textSecondary: '#6B778C',
  border: '#DFE1E6',
  success: '#28a745',
  danger: '#dc3545',
};
export const PageWrapper = styled.div`
  padding: 1.5rem;
  background-color: #f8fafc;
`;

export const Header = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0;

  /* --- RESPONSIVE --- */
  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const FormContainer = styled.div`
  padding: 1rem;
`;
export const GridContainer = styled.div`
  .dx-datagrid-headers {
    border-bottom: 1px solid ${colors.border};
    .dx-header-row {
      color: #000;
      font-weight: 700;
      font-size: 12px;
      text-transform: uppercase;
    }
  }

  `;
